module.exports = __webpack_public_path__ + "img/hair_front_female_bangs_mask.a5fb9ff7.png";